import * as React from "react";

import type { JSX } from "react/jsx-runtime";

const RasiNakshatraIconOrange = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M14.25 7.5V14.25H3.735V3.75H10.485V2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V7.5H14.25ZM12.045 5.955L12.75 7.5L13.455 5.955L15 5.25L13.455 4.545L12.75 3L12.045 4.545L10.5 5.25L12.045 5.955ZM9 6L8.0625 8.0625L6 9L8.0625 9.9375L9 12L9.9375 9.9375L12 9L9.9375 8.0625L9 6Z"
      fill="#FF9933"
    />
  </svg>
);

export default RasiNakshatraIconOrange;
